module.exports = "<svg id=\"1dcf038c-da23-4e46-9d44-f1be9f3d5adb\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 46.15 27.91\"><title>Email</title><path d=\"M5.07,11a3.24,3.24,0,0,0-1.31.27L23.88,28.43a1.87,1.87,0,0,0,2.08,0L46.09,11.27A3.24,3.24,0,0,0,44.78,11ZM2.2,12.76a3.23,3.23,0,0,0-.35,1.46V35.69a3.21,3.21,0,0,0,3.22,3.22H44.78A3.21,3.21,0,0,0,48,35.69V14.22a3.23,3.23,0,0,0-.35-1.46L27.35,30.05a3.77,3.77,0,0,1-4.86,0Z\" transform=\"translate(-1.85 -11)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Email.svg
// module id = 513
// module chunks = 1